import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20 4H3c-.5522 0-1 .4477-1 1v14c0 .5522.4478 1 1 1h17c.5523 0 1-.4478 1-1V5c0-.5523-.4477-1-1-1zm-8 15V6h8v13h-8zm-9 0V6h8v13H3z',
  ],
  height: 24,
  width: 24,
});
